//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';
import { useNavigate } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Button,
} from '@mui/material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import { Menu } from 'pages/Menu';
import { Spacer } from 'components/Spacer';

//#endregion

//-----------------------------------------------------------------
export function HeaderRuleList() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  //#endregion

  //region [STYLES]

  const BUTTON_FILES = {
    sx       : { height: '40px', width: '20px' },
    variant  : 'contained',
    onClick  : onClick,
    children : 'Files',
    name     : 'da_rules_btn',
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick( event ) {
    //-----------------------------------------------------------------
    navigate( '/analytics/files', { replace: true } );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Menu>
        <Spacer />
        <Styled styles={[{display: 'flex'}, {alignItems:'center'}]}>
          <Button { ...BUTTON_FILES } />
        </Styled>
      </Menu>
    )
  }

  //#endregion

  return display();
}
